import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "background": "#9DBFFF"
  }
};
const _hoisted_2 = {
  class: "block"
};
const _hoisted_3 = {
  class: "closew"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "最低成交价", -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title_sub"
}, "提交后可见,本地最低成交价~", -1);

const _hoisted_6 = {
  class: "car_lists",
  style: {
    "text-align": "center"
  }
};
const _hoisted_7 = {
  class: "select_car_img_name"
};
const _hoisted_8 = {
  class: "select_car_img_price"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode("点击询价");

const _hoisted_10 = {
  class: "top_image"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "formbox"
};

const _hoisted_13 = /*#__PURE__*/_createElementVNode("view", {
  class: "btitle_box"
}, [/*#__PURE__*/_createElementVNode("view", {
  class: "btitle_txt"
}, " 权益获取 ")], -1);

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" ｜ ");

const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#0E60F9"
  }
}, "更换车系", -1);

const _hoisted_16 = {
  ref: "captchaCanvas",
  width: "100",
  height: "36",
  class: "captcha-canvas"
};
const _hoisted_17 = {
  class: "form_tips",
  inset: ""
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 已阅读并同意《");

const _hoisted_19 = /*#__PURE__*/_createTextVNode("个人信息使用声明");

const _hoisted_20 = /*#__PURE__*/_createTextVNode("》。本服务由汽车之家提供，提交后汽车之家会通知【您选择地域的经销商】，由专业顾问为您电话服务。 ");

const _hoisted_21 = {
  class: "select_car_btn"
};

const _hoisted_22 = /*#__PURE__*/_createTextVNode("获取报价");

const _hoisted_23 = /*#__PURE__*/_createElementVNode("view", {
  class: "btitle_box"
}, [/*#__PURE__*/_createElementVNode("view", {
  class: "btitle_txt"
}, " 累计询价 ")], -1);

const _hoisted_24 = {
  class: "use_box_wrap"
};
const _hoisted_25 = {
  class: "use_box"
};

const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 车友 ");

const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "beian_link"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/#/Integrated/index",
  target: "_blank"
}, "鲁ICP备2021044545号-2")], -1);

const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = {
  class: "result_page_icon"
};
const _hoisted_30 = {
  class: "result_page_con"
};

const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "经销商会尽快和您取得联系,请耐心等待", -1);

const _hoisted_32 = {
  class: "city_cell"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_col = _resolveComponent("van-col");

  const _component_van_button = _resolveComponent("van-button");

  const _component_van_overlay = _resolveComponent("van-overlay");

  const _component_van_swipe_item = _resolveComponent("van-swipe-item");

  const _component_van_swipe = _resolveComponent("van-swipe");

  const _component_van_field = _resolveComponent("van-field");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  const _component_router_link = _resolveComponent("router-link");

  const _component_van_checkbox = _resolveComponent("van-checkbox");

  const _component_van_row = _resolveComponent("van-row");

  const _component_van_picker = _resolveComponent("van-picker");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker");

  const _component_van_index_anchor = _resolveComponent("van-index-anchor");

  const _component_van_cell = _resolveComponent("van-cell");

  const _component_van_index_bar = _resolveComponent("van-index-bar");

  return _openBlock(), _createElementBlock(_Fragment, null, [!$data.city_list_show && !$data.result_page_show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_overlay, {
    show: $data.close_box_show
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "wrapper",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_icon, {
      name: "cross",
      onClick: $options.doCloseAll,
      size: "2rem"
    }, null, 8, ["onClick"])]), _hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.recommend_list.related_recommend_series, (car, index) => {
      return _openBlock(), _createElementBlock("span", null, [index < 2 ? (_openBlock(), _createBlock(_component_van_col, {
        key: 0,
        span: "12",
        class: "car_lists_item",
        style: {
          "display": "inline-block",
          "width": "8rem",
          "text-align": "center"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(car['series_name']), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(car['price']) + "万起 ", 1)]),
        _: 2
      }, 1024)) : _createCommentVNode("", true)]);
    }), 256))]), _createVNode(_component_van_button, {
      type: "primary",
      onClick: $options.submitFormGoon,
      block: ""
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }, 8, ["onClick"])])])]),
    _: 1
  }, 8, ["show"]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_swipe, {
    class: "my-swipe",
    autoplay: 3000,
    "indicator-color": "white"
  }, {
    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2], cindex => {
      return _createVNode(_component_van_swipe_item, null, {
        default: _withCtx(() => [_createElementVNode("img", {
          class: "top_banner",
          src: '/assets/images/hld_' + cindex + '.png'
        }, null, 8, _hoisted_11)]),
        _: 2
      }, 1024);
    }), 64))]),
    _: 1
  })]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_van_cell_group, {
    inset: "",
    class: "select_car select_car_border"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $data.form.car_name,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.car_name = $event),
      readonly: "",
      label: "选择品牌车系",
      placeholder: "请选择车系",
      onClick: _cache[2] || (_cache[2] = $event => $data.car_box_show = true)
    }, {
      button: _withCtx(() => [_hoisted_14, _createVNode(_component_van_icon, {
        name: "exchange",
        color: "#0E60F9"
      }), _hoisted_15]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "select_car"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $data.form.city,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.city = $event),
      "is-link": "",
      readonly: "",
      label: "城市",
      placeholder: "请选择城市",
      onClick: _cache[4] || (_cache[4] = $event => $data.city_list_show = true)
    }, null, 8, ["modelValue"])]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "select_car"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $data.form.name,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.name = $event),
      label: "姓名",
      placeholder: "请输入姓名",
      "error-message": $data.error_name,
      onClick: $options.clearError
    }, null, 8, ["modelValue", "error-message", "onClick"])]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "select_car"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $data.form.phone,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.phone = $event),
      label: "手机号",
      placeholder: "请输入手机号",
      "error-message": $data.error_mobile,
      onClick: $options.clearError
    }, null, 8, ["modelValue", "error-message", "onClick"])]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "select_car"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $data.form.captcha,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.captcha = $event),
      center: "",
      clearable: "",
      label: "图片验证码",
      "error-message": $data.error_captcha,
      placeholder: "请输入图片验证码",
      onClick: $options.clearError
    }, {
      button: _withCtx(() => [_createElementVNode("div", {
        class: "captcha-wrapper",
        onClick: _cache[7] || (_cache[7] = (...args) => $options.refreshCaptcha && $options.refreshCaptcha(...args))
      }, [_createElementVNode("canvas", _hoisted_16, null, 512)])]),
      _: 1
    }, 8, ["modelValue", "error-message", "onClick"])]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "select_day"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $data.form.test_day,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.test_day = $event),
      "is-link": "",
      readonly: "",
      label: "预计试驾时间",
      placeholder: "请选择试驾时间",
      onClick: _cache[10] || (_cache[10] = $event => $data.car_time_show = true)
    }, null, 8, ["modelValue"])]),
    _: 1
  }), _createElementVNode("div", _hoisted_17, [_createVNode(_component_van_checkbox, {
    modelValue: $data.checked,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.checked = $event)
  }, {
    default: _withCtx(() => [_hoisted_18, _createVNode(_component_router_link, {
      to: 'info'
    }, {
      default: _withCtx(() => [_hoisted_19]),
      _: 1
    }), _hoisted_20]),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_van_row, {
    justify: "space-around"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, {
      span: "18"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_button, {
        class: "big_btn",
        type: "primary",
        onClick: $options.submitForm,
        block: "",
        color: "linear-gradient(to bottom, #0E60F9, #0E60F9)"
      }, {
        default: _withCtx(() => [_hoisted_22]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  })]), _hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", {
    id: "con1",
    ref: "con1",
    class: _normalizeClass({
      anim: $data.animate == true
    }),
    onMouseenter: _cache[12] || (_cache[12] = (...args) => $options.mEnter && $options.mEnter(...args)),
    onMouseleave: _cache[13] || (_cache[13] = (...args) => $options.mLeave && $options.mLeave(...args))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (u, index) => {
    return _openBlock(), _createBlock(_component_van_row, {
      class: _normalizeClass({
        use_box_row: true,
        use_box_row2: index % 2 == 0
      })
    }, {
      default: _withCtx(() => [_createVNode(_component_van_col, {
        span: "6"
      }, {
        default: _withCtx(() => [_hoisted_26]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "12"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(u[0]), 1)]),
        _: 2
      }, 1024), _createVNode(_component_van_col, {
        span: "6"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(u[1]), 1)]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1032, ["class"]);
  }), 256))], 34)])]), _createVNode(_component_van_popup, {
    show: $data.car_box_show,
    "onUpdate:show": _cache[15] || (_cache[15] = $event => $data.car_box_show = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      title: "请选择车型",
      columns: $data.car_select,
      onConfirm: $options.onCarConfirm,
      onCancel: _cache[14] || (_cache[14] = $event => $data.car_box_show = false)
    }, null, 8, ["columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.car_time_show,
    "onUpdate:show": _cache[20] || (_cache[20] = $event => $data.car_time_show = $event),
    position: "bottom",
    style: {
      height: '40%'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_van_datetime_picker, {
      modelValue: $data.currentDate,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.currentDate = $event),
      type: "date",
      onChange: _cache[17] || (_cache[17] = $event => $options.changeFn()),
      onConfirm: _cache[18] || (_cache[18] = $event => $options.confirmFn()),
      onCancel: _cache[19] || (_cache[19] = $event => $data.car_time_show = false)
    }, null, 8, ["modelValue"])]),
    _: 1
  }, 8, ["show"]), _hoisted_27])) : _createCommentVNode("", true), $data.result_page_show ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_van_icon, {
    name: "completed",
    color: "green",
    size: "3rem"
  })]), _createElementVNode("div", _hoisted_30, [_createElementVNode("b", null, _toDisplayString($data.form.car_name) + " 询价成功!", 1), _hoisted_31])])) : _createCommentVNode("", true), $data.city_list_show ? (_openBlock(), _createBlock(_component_van_index_bar, {
    key: 2,
    "index-list": _ctx.indexList
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.city_list, cv => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_index_anchor, {
        index: $options.toUp(cv.initials),
        onSelect: $options.selectIndex
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.toUp(cv.initials)), 1)]),
        _: 2
      }, 1032, ["index", "onSelect"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cv.city, ccv => {
        return _openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_van_cell, {
          onClick: $event => $options.selectCity(ccv.city_name),
          title: ccv['city_name']
        }, null, 8, ["onClick", "title"])]);
      }), 256))]);
    }), 256))]),
    _: 1
  }, 8, ["index-list"])) : _createCommentVNode("", true)], 64);
}